import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs/Subscription";
import { Store } from "@ngrx/store/src/store";
import { Angular2TokenService } from "angular2-token";

import { POPULATE_EDITABLE_CREDIT_CARD, PURCHASE_TICKETS_AS_EXISTING, CLEAR_EVENT_ERRORS } from "@reducers/events";

import { AppState } from "@store/app-state";
import { EventsStore } from "@store/events";
import { UserStore } from "@store/user";

import { CreditCard } from "@models/credit-card";
import { Event } from "@models/event";
import { Contact } from "@models/contact";

@Component({
  selector: 'purchase-ticket-existing-form',
  templateUrl: './purchase-ticket-existing-form.pug',
})
export class PurchaseTicketExistingFormComponent implements OnInit, OnDestroy {

  public event: Event
  public errors: any
  public currentUserContact: Contact
  public currentUserGuardian: Contact

  public loading: boolean = false

  private userSubscription: Subscription
  private eventsSubscription: Subscription

  constructor(
    private store: Store<AppState>,
    private tokenService: Angular2TokenService,
  ) {}

  ngOnInit() {
    this.store.dispatch({ type: CLEAR_EVENT_ERRORS })
    this.store.dispatch({ type: POPULATE_EDITABLE_CREDIT_CARD, payload: new CreditCard() })

    this.eventsSubscription = this.store.select("eventsReducer").subscribe(
      (s: EventsStore) => {
        this.event = s.activeEvent
        this.errors = s.errors
        this.loading = s.loading
      })

    this.userSubscription =
      this.store.select("userReducer").subscribe((s: UserStore) => {
        this.currentUserContact = s.currentUserContact
        this.currentUserGuardian = s.currentUserContact.guardian
      })
  }

  clickedPay() {
    const taIds =
      this.event.ticketAllocations
        .filter(ta => ta.uiState.isPurchasing)
        .map(ta => ta.id)

    const payload =
      Event.createPurchaseTicketAsExistingPayload(
        this.currentUserContact, taIds)

    this.store.dispatch({ type: CLEAR_EVENT_ERRORS })
    this.store.dispatch({ type: PURCHASE_TICKETS_AS_EXISTING, payload: payload })
  }

  getKeys(errors: any): string[] { return Object.keys(errors) }

  ngOnDestroy() {
    this.eventsSubscription.unsubscribe()
    this.userSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/public/purchase-ticket-existing-form.ts